import { render, staticRenderFns } from "./PDFview.vue?vue&type=template&id=b4cb1426&"
import script from "./PDFview.vue?vue&type=script&lang=js&"
export * from "./PDFview.vue?vue&type=script&lang=js&"
import style0 from "./PDFview.vue?vue&type=style&index=0&id=b4cb1426&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports